export const locale = {
  lang: 'tr',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO':'Bu bir Odak Alanı sürecidir',
        'NO-ENCU':'Şu anda atanmış bir anket süreciniz yok',
        'ENC-AUTO':'Yetkili Anket',
        'ENC-CORRECI':'Anket düzeltme için gönderildi',
        'MODAL_NO_COLAB_EMPRE':'Henüz katılımcı tabanınızı yüklemediniz, devam edeceğinizden emin misiniz?',

      },
      'STATUS-ENCUESTA':{
        '1': 'İşlemde',
        '2': 'Değerlendir',
        '3': 'Yetkili',
        '5': 'Doğru',

      },
      'LISTA': {
        'TAB': 'Katılımcı listesi',
        'BUSCAR': {
          'INFO': 'Aşağıdaki adı yazarak listeden bir veya daha fazla katılımcı arayabilirsiniz.',
          'PLACEHOLDER': 'Bir katılımcı bulun'
        },
        'AGREGAR': {
          'BOTON': 'Katılımcı ekleyin'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': 'Ad Soyad',
            'EMAIL': 'E-posta adresi',
            'ACCIONES': 'Mevcut Eylemler'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': 'Listeye bir katılımcı ekleyin',
          'EDITAR': 'Bu katılımcı verilerini düzenleyin'
        }
      },
      'MODALES':{
        'CREARENC': 'Anketin Adını Girin',
        'DELETE': 'Gerçekten ortadan kaldırmak istiyorsun',
        'CORRECTO': 'Doğru şekilde eklendi',
        'COMDELETE': 'Doğru şekilde kaldırıldı',
        'RSPSI':'EVET',
        'RSPNO':'HAYIR',
        'RSPOK':'tamam',
        'RSPACEPTAR':'Kabul etmek',
        'CARGANDOLISTA': 'Katılımcı listesi alınıyor, lütfen biraz bekleyin'

      },
      'WIZARD':{
        'CARGANDOF': 'Satın alınan ürünlerin yüklenmesi',
        'SINPRODS': 'Bu ürünü alamadınız',
        'CREARENC': 'Anket oluştur',
        'DONE': 'Başvuru yılı ',
        'TITULO': 'ODAK ALANINA HOŞGELDİNİZ',
        'TFOCUS': 'ANKETE ODAK ALANINA',
        'DELETE': 'Sil',
        'EDIT': 'Düzenle',
        'VERIPRE':'Soruları kontrol edin',
        'AVANCE':'İlerlemek',
        'TITUVERI':'Soruların doğrulanması',
        'TITUTABTEM':'Şablonlar hakkında sorular',
        'TITUTABADI':'kişiselleştirilmiş sorular',
        'TITUTAUTORIZADA':'Yetkili Anket',
        'TITUTNOAUTORIZADA':'Anketi Yetkilendirme',
        'TITUTAUTORIZAR':'Anketi Yetkilendir',
        'TITUTCORREGIR':'Doğru Anket',
      },
      'TABLACAMPOS':{
        'NAME':'Anket adı',
        'FECHAI':'Başlangıç tarihi',
        'FECHAF':'Hedeflenen tarih',
        'AVANCE':'İlerlemek',
        'ESTADO': 'Durum',
        'ACCION': 'Davranış',
      },
      'COLABORADORES':{
        'CARGACOLAB':'Sertifikalı Ortak Çalışanları Yükle'
      },
      'ADMIN-PREG':{
        'TITULO-ABIE':'Açık sorular',
        'PREGUN':'Sorular',
        'PREGUNSUB':'Soru',
        'DESCRIP-PREGUN':'Soruyu görüntülemek için buraya tıklayın',
        'TITULO-UNAOPC':'Tek seçenekli sorular',
        'TITULO-MULOPC':'Çoktan seçmeli sorular',
        'OPC':'Seçenekler',
        'OPCSUB':'seçenek',
        'NO-ADICI':'Ankette ek soru yok',
      },
      'STEP_COLAB':{
        'STEP_1':{
          'TITULO_STEP_ELEGIR_COLAB':'Ortak çalışanların seçimi',
          'INST_1':'Aşağıdaki seçeneklerden birini seçin',
          'NUEVA_BASE_COLA':'Yeni katılımcı tabanı yükleyin',
          'BASE_COLAB_EXIS':'Katkıda bulunan ana tabanını kullan',
          'BTN_SIGUENTE':'Sonraki',

        },
        'STEP_2':{
          'TITULO_STEP_SUBIR_COLAB':'Katkıda bulunanların seçimi',
          'MAT_TITLE_DEMO_SELE':'Seçilmiş demografi',
          'ALERT_NOT_DEMO_SELE':'Henüz filtre seçmediniz',
          'ALERT_NOT_SELE_COLAB':'Hiçbir ortak çalışan eklenmedi',
          'AGREGAR_FILTRO':'Filtre ekle',
          'TH_NOMBRE':'Katkıda bulunan adı',
          'TH_ACCION':'Hareketler',
          'INTS_SEL_1_O_MAS_COLAB':'*Not: bir veya daha fazla ortak çalışan seçin',
          'SIN_RESULTADOS':'Mevcut filtre seçimi herhangi bir sonuç döndürmedi, filtreleri değiştirmeyi deneyin ve tekrar deneyin',
          'BTN_REGRESAR':'Dönüş',
          'BTN_AGRE_COLAB':'Ortak çalışan ekle',
          'BTN_GUAR_COLAB':'Ortak çalışanları kaydedin',
          'BTN_BORR_COLAB':'Ortak çalışanları sil',
          'BTN_ACEPTAR':'Kabul etmek',
          'BTN_BUSCAR':'Arama',
          'TITULO_MODAL_DEMOGRA':'Demografik bilgiler listesi',
          'MAT_TITLE_EXPA_RESULT':'Katkıda bulunan arama sonuçları:',
          'MAT_TITLE_EXPA_AGREG':'Ortak çalışanlar:',
          'MAT_TITLE_EXPA_DESCRIP':'Ortak çalışanları görün',
          'MODALES':{
            'MODAL_CARGAN_FILTROS':'Filtreler yükleniyor',
            'MODAL_BUSCA_COLAB':'Filtrelenmiş ortak çalışanlar aranıyor',
            'MODAL_AGRE_COLAB':'Ortak çalışanlar ekleme',
            'MODAL_DELET_COLAB':'Ortak çalışan bilgilerini silme',
            'MODAL_SUCCES_AGRE_COLAB':'Ortak çalışanlar başarıyla eklendi',
            'MODAL_GUAR_COLAB':'Ortak çalışanları kaydetme',
            'MODAL_CONFIR_BORRAR_COLAB':'Katkıda bulunan kişiyi silmek istediğinizden emin misiniz?',
            'MODAL_CONFIR_BORRAR_COLABRES':'Ortak çalışanları silmek istediğinizden emin misiniz?',
            'MODAL_CONFIR_GUAR_COLAB_BACK':'Eklenen ortak çalışanları kaydettiğinizden emin misiniz?',
            'MODAL_SUCCES_GUAR_COLAB':'Ortak çalışanlar doğru şekilde kaydedildi',
            'MODAL_SUCCES_BORRA_COLAB':'Katkıda bulunan doğru şekilde silindi',
            'MODAL_SUCCES_BORRA_COLABRES':'Katkıda bulunanlar başarıyla silindi',
            'MODAL_WARNN_NO_SELECT_COLAB':'Henüz herhangi bir ortak çalışan seçmediniz',
            'BTN_SI':'Evet',
            'BTN_NO':'Yapma',
            'BTN_OK':'Tamam',
          },
          'FORMULARIO':{
            'fullName': 'Ad Soyad',
            'ownKey': 'Çalışan sayısı',
            'age': 'doğum yılı',
            'surveyKey': 'anket erişim anahtarı',
            'email': 'e-posta',
            'bossName': 'doğrudan patron adı',
            'bossKey': 'doğrudan patron numarası',
            'country': 'ülke',
            'location': 'yer',
            'geo_1': 'coğrafi seviye 1',
            'geo_2': 'coğrafi seviye 2',
            'geo_3': 'coğrafi seviye 3',
            'geo_4': 'coğrafi seviye 4',
            'geo_5': 'coğrafi seviye 5',
            'geo_6': 'coğrafi seviye 6',
            'geo_7': 'coğrafi seviye 7',
            'geo_8': 'coğrafi seviye 8',
            'geo_9': 'coğrafi seviye 9',
            'geo_10': 'coğrafi seviye 10',
            'structure_1': 'yapısal seviye 1',
            'structure_2': 'yapısal seviye 2',
            'structure_3': 'yapısal seviye 3',
            'structure_4': 'yapısal seviye 4',
            'structure_5': 'yapısal seviye 5',
            'structure_6': 'yapısal seviye 6',
            'structure_7': 'yapısal seviye 7',
            'structure_8': 'yapısal seviye 8',
            'structure_9': 'yapısal seviye 9',
            'structure_10': 'yapısal seviye 10',
            'area': 'alan',
            'bUnit': 'iş ünitesi',
            'enterDate': 'şirkete giriş tarihi',
            'antiquity': 'antik dönem',
            'antiquityUS': 'Antik bize',
            'generation': 'nesil',
            'generationUS': 'bize nesil',
            'ageUS': 'yaş',
            'charge': 'şirketteki konumu veya işlevi',
            'homologado': 'şarj veya işlev onaylandı',
            'homologadoUS': 'ücret veya işlev bizi onayladı',
            'gender': 'Cinsiyet',
            'genderType': 'cinsiyet türü',
            'typeofwork': 'tazminat türü',
            'workCondition': 'çalışma şartı',
            'academico': 'akademik derece',
            'contratacion': 'sözleşme tipi',
            'situacionUS': 'çalışma durumu bize',
            'personal': 'çalışan tipi',
            'jornada': 'çalışma programı türü',
            'rotacion': 'vardiya dönüşü yapar',
            'phone': 'ortak çalışanın telefonu',
            'extension': 'ortak çalışanın doğrudan uzantısı',
            'cellphone': 'işbirlikçinin cep telefonu',
            'native': 'anadil',
            'answer': 'Cevap',
            'other_1': 'diğerleri 1',
            'other_2': 'diğerleri 2',
            'other_3': 'diğerleri 3',
            'other_4': 'diğerleri 4',
            'other_5': 'diğerleri 5',
            'other_6': 'diğerleri 6',
            'other_7': 'diğerleri 7',
            'other_8': 'diğerleri 8',
            'other_9': 'diğerleri 9',
            'other_10': 'diğerleri 10',
          },
        },
    }

    }
  }
};
